import { render, staticRenderFns } from "./SyncView.vue?vue&type=template&id=d53f1006&scoped=true"
import script from "./SyncView.vue?vue&type=script&lang=js"
export * from "./SyncView.vue?vue&type=script&lang=js"
import style1 from "./SyncView.vue?vue&type=style&index=1&id=d53f1006&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53f1006",
  null
  
)

export default component.exports